var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.167 1.5A6.67 6.67 0 0 0 1.5 8.167a6.669 6.669 0 0 0 6.667 6.666c3.68 0 6.666-2.986 6.666-6.666S11.847 1.5 8.167 1.5zm.666 10H7.5v-4h1.333v4zm0-5.333H7.5V4.833h1.333v1.334z"
})));
export default SvgInfo;